import React from 'react';

type Props = {
    description?: string;
};

export const LimitedTimeOffer: React.FC<Props> = ({
    description = 'You have access to subscriber features as part of our limited time offer',
}) => {
    return <div className="limited-time-offer">{description}</div>;
};
